<template>
  <v-app>
    <v-content>
      <loading v-if="getLoading"></loading>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Loading from "./components/Loading";
import { mapGetters } from "vuex";

export default {
  name: "App",
  // import loading component for whole application
  components: {
    Loading
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapGetters("global", ["getLoading"])
  }
};
</script>
